// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"513":"d5586069","534":"0f1649f6","607":"f89a29eb","978":"dece088f"}[chunkId] + ".js";
};